import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { ProfessionalsPayrollDashboardPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import { PayrollResultFilterProvider } from 'modules/bookkeepers/hooks/PayrollResultContext'
import { useClientsContext } from 'modules/bookkeepers/hooks/useClientsContext'
import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

const PayrollDashboard = () => {
  const { selectedCompanyId } = useClientsContext()
  const bookkeeperContext = {
    isBookkeeperView: true,
  }
  const { data, loading } = useQuery(ProfessionalsPayrollDashboardPageDocument, {
    variables: {
      companyId: Number(selectedCompanyId),
    },
    skip: !selectedCompanyId,
    context: bookkeeperContext,
  })

  const hasDevCompensations =
    data?.features?.featuresConnection.nodes.some(
      (feature) => feature.name === 'dev_compensations' && feature.enabled
    ) ?? false

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <AuthorizeUser authorizeFn={() => !hasDevCompensations}>
      <PayrollResultFilterProvider defaultValues={{ status: PayrollStatus.PAYROLL_CALCULATION }}>
        <Box>
          <Outlet context={{ selectedCompanyId }} />
        </Box>
      </PayrollResultFilterProvider>
    </AuthorizeUser>
  )
}

export default PayrollDashboard
